<template>
  <div v-bind:class="'single-box' + (content ? ' show-content' : '')">
    <div class="img-wrap">
      <img v-if="name === 'SEARCH'" src="~@/assets/images/search-img.jpg" />
      <img v-if="name === 'CONNECT'" src="~@/assets/images/connect-img.png" />
      <img v-if="name === 'FLY'" src="~@/assets/images/fly-img.jpg" />
      <div class="mob-title">
        <h4>{{ name }}</h4>
        <a href="javascript:;" @click="showContent">
          <img src="~@/assets/images/down-arrow.png" />
        </a>
      </div>
    </div>
    <div class="content-wrap">
      <h4>{{ name }}</h4>
      <div class="ctn">
        <p>
          {{ text }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ContentBox",
  props: {
    name: String,
    text: String,
  },
  data() {
    return {
      content: false,
    };
  },

  methods: {
    showContent() {
      this.content = !this.content;
    },
  },
};
</script>
